import { cn } from '@/lib/utils'
import { LockToolTipIcon } from '../upgrade-lock-icon-layout'
import { FormLabel } from './form'

export const CustomLabelWithLock = ({
  title,
  hasAbility,
}: {
  title: string
  hasAbility: boolean
}) => {
  return (
    <FormLabel
      className={cn(
        'text-base font-bold flex flex-row gap-1 items-center',
        !hasAbility && 'opacity-50'
      )}
    >
      {title}
      {!hasAbility && <LockToolTipIcon show={true} className="w-4 h-4" />}
    </FormLabel>
  )
}
